export default __webpack_public_path__ + "static/media/dsaf-assignment03.docx.369f98ab.pdf";